import { Grid } from "antd";
import { MdSupportAgent } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";

const SUPPORT_WHATSAPP = "201112513037";

export default function ContactUs() {
  const { t } = useTranslation();
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const href = isLargeScreen ? `https://web.whatsapp.com/send?phone=${SUPPORT_WHATSAPP}` : `https://wa.me/${SUPPORT_WHATSAPP}`;
  return (
    <div className="flex">
      <a className="text-font-active flex items-center gap-1 text-sm font-semibold" href={href} target="_blank" rel="noopener noreferrer">
        <MdSupportAgent className="size-4" aria-hidden="true" />
        {t("UserHistory.hotel.contactSupport")}
      </a>
    </div>
  );
}
